import classNames from 'classnames';
import Button from 'src/components/button/Button';
import WatchlistSvg from 'src/components/svg/WatchlistSvg';
import styles from './WatchlistButton.module.css';

//#region [Props]
type WatchlistButtonProps = {
	isWatchlisted: boolean;
	onWatchlistClick: () => void;
	className?: string;
};
//#endregion

//#region [Component]
export default function WatchlistButton({ isWatchlisted, onWatchlistClick, className }: WatchlistButtonProps) {
	return <Button className={classNames(styles.SWatchlistButton, className)}
		text='Legg i huskelisten'
		icon={<WatchlistSvg className={styles.SWatchlistSvg} selected={isWatchlisted} />}
		onClick={onWatchlistClick}
	/>;
}
//#endregion
